import { Tab, TabProps } from "@mui/material"

export const StandardTab = (props: TabProps) => <Tab {...props} wrapped sx={{ textTransform: "none" }} />
